import {
  useGetPendingInviteQuery,
  useGetUserQuery,
} from '@/app/redux/endpoints/user';
import { useAppSelector } from '@/app/redux/hooks';
import {
  selectClaims,
  selectIsAuthenticated,
  selectIsEmailVerified,
  selectSessionUserDetails,
  selectUserId,
} from '@/app/redux/slices/sessionSlice';

export function useUser() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const userId = useAppSelector(selectUserId);
  const claims = useAppSelector(selectClaims);

  const {
    data: user = null,
    isLoading,
    error,
  } = useGetUserQuery(userId ?? '', { skip: !isAuthenticated || !claims });

  return {
    user,
    isLoading,
    error,
  };
}

export function usePendingInvite() {
  const email = useAppSelector(selectSessionUserDetails)?.email ?? null;
  const isEmailVerified = useAppSelector(selectIsEmailVerified);
  const claims = useAppSelector(selectClaims);

  const skip = !email || !isEmailVerified || !claims || !claims.role;

  const {
    data: pendingInvite = null,
    isLoading,
    isUninitialized,
  } = useGetPendingInviteQuery(email ?? '', { skip });

  return { pendingInvite, isLoading: isLoading || (!skip && isUninitialized) };
}
